"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const obstacleDuration_1 = __importDefault(require("../constants/obstacleDuration"));
const state_1 = __importDefault(require("../state"));
const getRecentPausedTime_1 = __importDefault(require("./getRecentPausedTime"));
const hasPausedSinceObstacle_1 = __importDefault(require("./hasPausedSinceObstacle"));
const isCootsInObstacle = () => {
    if (state_1.default.hasHitObstacleAt()) {
        let amount = state_1.default.currentTime - state_1.default.hitObstacleAt;
        if ((0, hasPausedSinceObstacle_1.default)()) {
            amount -= (0, getRecentPausedTime_1.default)();
        }
        return amount < obstacleDuration_1.default;
    }
    return false;
};
exports.default = isCootsInObstacle;
